/* In the NAme of the Father and to the Son and to The Holy Spirit Amen. St Carlos Pray for us, St Thomas Aquinas Pray for US*/
import React from 'react';
import ReactDOM from 'react-dom/client'; // Use 'react-dom/client' for React 18+
import App from './App'; 
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './i18n';

import { AuthProvider } from './auth/AuthContext'; 
import ErrorBoundary from './ErrorBoundary'; // Import the ErrorBoundary component
// Load CSS file from environment variable
const cssPath = `${process.env.REACT_APP_URL}/styles/css/bootstrap.min.css`; // Ensure REACT_APP_URL is defined in your .env file
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = cssPath;
document.head.appendChild(link);  
function hideInitialSpinner() {
  const spinner = document.getElementById('spinner');
  if (!spinner) return;

  spinner.classList.remove('show');
  spinner.style.visibility = 'hidden';
  spinner.style.opacity = '0';
  spinner.style.display = 'none';
}

// Create a root to render the App
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the application with AuthProvider
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </AuthProvider>
  </React.StrictMode>
);

// Fail-safe: prevent template spinner from persisting on deep links.
hideInitialSpinner();
